<template>
  <ContentBase isPackage>
    <Row>
      <template #service>
        <BaseText :bold="isSmallScreen">
          {{ servicePackage?.name }}
        </BaseText>
      </template>

      <template
        #duration
        v-if="!isSmallScreen"
      >
        <BaseText>
          {{ `${totalDuration} ${$t('global.minute_short')}` }}
        </BaseText>
      </template>
    </Row>

    <Flex
      :gap="0"
      direction="column"
      fullWidth
    >
      <ServiceRow
        v-for="(part, index) in parts"
        :key="partIndexes[index]"
        :part="part"
        :partIndex="partIndexes[index]"
        v-test="'package-part-subrow'"
      />
    </Flex>

    <Flex
      direction="column"
      :gap="0.5"
    >
      <Flex v-if="isSmallScreen">
        <BaseText>
          {{ `${totalDuration} ${$t('global.minute_short')}` }}
        </BaseText>

        <SelectedResource :selectedResourceIds="selectedResourceIds" />
      </Flex>

      <BaseText
        inline
        @click.stop="onSplit"
        v-test="'package-part-split'"
      >
        {{ $t('appointment.create.split_into_services') }}
      </BaseText>
    </Flex>
  </ContentBase>
</template>

<script
  lang="ts"
  setup
>
import { getPartResources } from '@/modules/calendar/appointment/helpers';
import { isSmallScreen } from '@/modules/calendar/appointment/helpers.ts';
import { useCreateAppointmentStore } from '@/stores/calendar-create-appointment';
import type { Resource, ServicePackage } from '@/types';
import { usePackageParts } from '../../part-rows';
import ContentBase from './ContentBase.vue';
import Row from './Row.vue';
import SelectedResource from './SelectedResource.vue';
import ServiceRow from './ServiceRow.vue';

const props = withDefaults(
  defineProps<{
    partIndexes: number[];
    servicePackage: ServicePackage;
  }>(),
  {
    servicePackage: () => undefined,
  },
);

const { splitPackageParts } = useCreateAppointmentStore();
const { parts, totalDuration } = usePackageParts(() => props.partIndexes);

const onSplit = () => {
  splitPackageParts(props.partIndexes);
};

const selectedResourceIds = computed<Resource['id'][]>(() => [
  ...new Set(
    parts.value.reduce<Resource['id'][]>(
      (resourceIds, part) => resourceIds.concat(getPartResources(part)),
      [],
    ),
  ),
]);
</script>
